module.exports = __webpack_public_path__ + "static/mo04-43c9abd3d63378c5265d7a93c44f1636.png";